<template>
  <div class="flex justify-start">
    <div class="px-4 py-3 rounded-2xl rounded-tr-md bg-slate-50 border border-slate-200">
      <div class="flex items-center gap-2">
        <span class="flex gap-1 items-center">
          <span class="w-1.5 h-1.5 bg-pink-400 rounded-full animate-bounce" style="animation-delay: 0s" />
          <span class="w-1.5 h-1.5 bg-pink-400 rounded-full animate-bounce" style="animation-delay: 0.15s" />
          <span class="w-1.5 h-1.5 bg-pink-400 rounded-full animate-bounce" style="animation-delay: 0.3s" />
        </span>
        <span class="text-slate-500 text-sm">{{ label }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>
